{
  "addons.addonList": "Списък",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Създайте и извлечете вашия API ключ от тази връзка",
  "addons.ambientWeatherDescription": "Ambient Weather метеостанции (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API ключ",
  "addons.applicationKey": "Ключ за приложение",
  "addons.connect": "Свържете се",
  "addons.davisApiSecret": "Поверителен ключ API",
  "addons.davisApiV2Key": "V2 API ключ",
  "addons.davisDescription": "Davis weather метеостанции (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Извлечете вашия API ключ от тази връзка",
  "addons.disconnect": "Прекъснете",
  "addons.ecowittCreateAndRetrieveKeys": "Създайте и извлечете едновременно вашия API ключ и ключ за приложението от тази връзка",
  "addons.ecowittDescription": "Ecowitt предлага професионални безжични метеорологични станции, безжични вътрешни външни термометри, монитори за влажност, високо прецизни дъждомери, монитори за качество на въздуха и др.",
  "addons.helpLink": "Как да свържете {provider}",
  "addons.myAcuriteAccountOnHold": "Вашият акаунт е задържан. Моля, въведете паролата си, за да свържете отново акаунта си",
  "addons.myAcuriteDescription": "AcuRite е марка метеорологични станции №1 в Северна Америка. Като лидер в технологиите за времето, температурата и времето, AcuRite ви предоставя подробна информация за вашата вътрешна и външна среда, така че да можете да планирате деня си с увереност.",
  "addons.myAcuriteEnterCredentials": "Въведете вашите идентификационни данни за My AcuRite, за да свържете своя акаунт в My AcuRite със SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Използвайте термостата си Netatmo, за да промените температурата в дома си, от леглото си или от другия край на света.",
  "addons.netatmoThermostat": "Netatmo термостат",
  "addons.netatmoWeather": "Netatmo Време",
  "addons.netatmoWeatherDescription": "Вашата метеостанция вкъщи",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Връзката с вашата метеорологична услуга е изтекла. Моля, свържете се отново, за да възобновите актуализациите на данните.",
  "addons.reconnect": "Свържете се отново",
  "addons.weatherflowCreateToken": "Създайте и извлечете своя токен от тази връзка",
  "addons.weatherflowTempestDescription": "Система Tempest Weather с вграден ветромер, дъждомер",
  "addons.wundergroundApiKey": "API ключ",
  "addons.wundergroundDescription": "Weather Underground е глобална общност от хора, предоставящи данни от сензори за околната среда като метеорологични станции и монитори за качество на въздуха, за да можем да ви поднесем хипер данни, от които се нуждаете, за да практикувате хобито си",
  "addons.wundergroundRetrieveApiKey": "Извлечете вашия API ключ от тази връзка",
  "addons.wundergroundRetrieveStationId": "Изтеглете ID на вашата станция от тази връзка",
  "addons.wundergroundStationId": "ID на метеостанцията",
  "airQuality.airQuality": "Качество на въздуха",
  "airQuality.airQualityIndex": "Индекс за качество на въздуха",
  "airQuality.aqiForecast": "Прогноза за качеството на въздуха",
  "airQuality.co": "Въглероден окис",
  "airQuality.dailyForecast": "Дневна прогноза",
  "airQuality.details": "Детайли",
  "airQuality.dominantPollutant": "Доминиращ замърсител",
  "airQuality.good": "Добро",
  "airQuality.goodDescription": "Качеството на въздуха се счита за задоволително и замърсяването на въздуха представлява малък или никакъв риск",
  "airQuality.hazardous": "Замърсено",
  "airQuality.hazardousDescription": "Сигнал за здравето: вероятност за сериозни последици за здравето",
  "airQuality.indoorAirQuality": "Качество на въздуха в помещението",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Умерено",
  "airQuality.moderateDescription": "Качеството на въздуха е приемливо; въпреки това има риск за здравето на много малък брой хора, които са необичайно чувствителни към замърсяването на въздуха.",
  "airQuality.no2": "Азотен диоксид",
  "airQuality.o3": "Озон",
  "airQuality.pm10": "Частици с диаметър 10 μm или по-малък",
  "airQuality.pm25": "Частици с диаметър 2.5 μm или по-малък",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Нездравословно за чувствителни хора",
  "airQuality.sensitiveUnhealthyDescription": "Чувствителни хора биха могли да имат последици за здравето. Минимален риск за повечето хора.",
  "airQuality.so2": "Серен диоксид",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Нездравословно",
  "airQuality.unhealthyDescription": "Вероятни последици за здравето за всички; Чувствителни хора могат да имат по-сериозни последици за здравето",
  "airQuality.veryUnhealthy": "Изключително нездравословно",
  "airQuality.veryUnhealthyDezscription": "Предупреждение за извънредно нездравословно събитие. Вероятност за засягане на цялото население.",
  "alerts.addAlert": "Добавете предупреждение",
  "alerts.addCondition": "Добавете състояние",
  "alerts.alertAdded": "Предупреждението е добавено успешно",
  "alerts.alertAuthorizationNotice": "Предупрежденията ще работят само ако разрешите на SmartMixin да показва известия",
  "alerts.alertDeleted": "Предупреждението е изтрито успешно",
  "alerts.alertEdited": "Предупреждението е променено успешно",
  "alerts.alertName": "Име на предупреждението",
  "alerts.alertWhen": "Желая да бъда предупреден, когато:",
  "alerts.aqiGreaterThan": "Индекс на качеството на въздуха, по-голям от",
  "alerts.aqiGreaterThanThreshold": "Индекс на качеството на въздуха по-голям от прага на {value}{unit}",
  "alerts.aqiLessThan": "Индекс на качеството на въздуха, по-малък от",
  "alerts.aqiLessThanThreshold": "Индекс на качеството на въздуха по-малък от прага на {value}{unit}",
  "alerts.atLeastOneCondition": "Трябва да добавите поне едно условие",
  "alerts.co2GreaterThan": "CO2 над",
  "alerts.co2GreaterThanThreshold": "CO2 над праг от {value}{unit}",
  "alerts.co2LessThan": "CO2 под",
  "alerts.co2LessThanThreshold": "CO2 под прага от {value}{unit}",
  "alerts.conditions": "Условия",
  "alerts.createAlert": "Създай предупреждение",
  "alerts.dailyPrecipitationGreaterThan": "Дневни валежи по-големи от",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Дневни валежи над прага от {value}{unit}",
  "alerts.deleteAlert": "Изтрий предупреждение",
  "alerts.editAlert": "Промени предупреждение",
  "alerts.editCondition": "Промени условие",
  "alerts.gustSpeedGreaterThan": "Скорост на порива по-голяма от",
  "alerts.gustSpeedGreaterThanThreshold": "Скорост на порива над праг от {value}{unit}",
  "alerts.gustSpeedLessThan": "Скорост на порива по-малка от",
  "alerts.gustSpeedLessThanThreshold": "Скорост на порива под праг от {value}{unit}",
  "alerts.heatIndexGreaterThan": "Топлинен индекс по-голям от",
  "alerts.heatIndexGreaterThanThreshold": "Топлинен индекс по-голям от прага на {value}{unit}",
  "alerts.heatIndexLessThan": "Топлинен индекс по-малък от",
  "alerts.heatIndexLessThanThreshold": "Топлинен индекс по-малък от прага на {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex по-голям от",
  "alerts.humidexGreaterThanThreshold": "Humidex по-голям от прага на {value}{unit}",
  "alerts.humidexLessThan": "Humidex по-малък от",
  "alerts.humidexLessThanThreshold": "Humidex по-малък от прага на {value}{unit}",
  "alerts.humidityGreaterThan": "Влажност по-голяма от",
  "alerts.humidityGreaterThanThreshold": "Влажност над праг от {value}{unit}",
  "alerts.humidityLessThan": "Влажност по-малка от",
  "alerts.humidityLessThanThreshold": "Влажност под праг от {value}{unit}",
  "alerts.inProgress": "Действащи",
  "alerts.myAlerts": "Мои предупреждения",
  "alerts.noConfiguredAlert": "Все още нямате конфигурирани предупреждения, добавете поне едно",
  "alerts.noiseGreaterThan": "Шум по-голям от",
  "alerts.noiseGreaterThanThreshold": "Шум над праг от {value}{unit}",
  "alerts.noiseLessThan": "Шум по-малък от",
  "alerts.noiseLessThanThreshold": "Шум под праг от {value}{unit}",
  "alerts.noteOnConditions": "Имайте предвид, че предупреждението се задейства, когато всички условия по-долу са потвърдени",
  "alerts.noTriggerHistory": "Това предупреждение все още не е задействано.",
  "alerts.pm10GreaterThan": "Прахови частици 10 над",
  "alerts.pm10GreaterThanThreshold": "Прахови частици 10 над праг от {value}{unit}",
  "alerts.pm10LessThan": "Прахови частици 10 под",
  "alerts.pm10LessThanThreshold": "Прахови частици 10 под праг от {value}{unit}",
  "alerts.pm1GreaterThan": "Прахови частици 1 над",
  "alerts.pm1GreaterThanThreshold": "Прахови частици 1 над праг от {value}{unit}",
  "alerts.pm1LessThan": "Прахови частици 1 под",
  "alerts.pm1LessThanThreshold": "Прахови частици 1 под праг от {value}{unit}",
  "alerts.pm2p5GreaterThan": "Прахови частици 2.5 над",
  "alerts.pm2p5GreaterThanThreshold": "Прахови частици 2.5 над праг от {value}{unit}",
  "alerts.pm2p5LessThan": "Прахови частици 2.5 под",
  "alerts.pm2p5LessThanThreshold": "Прахови частици 2.5 под праг от {value}{unit}",
  "alerts.postStormSummary": "Обобщение след дъжда",
  "alerts.postStormSynopsisHelper": "Ще получите обобщаващо известие след края на всеки дъжд.",
  "alerts.postStormSynopsisSoleCondition": "Обобщение след буря не може да се комбинира с други условия.",
  "alerts.precipitationGreaterThan": "Часови валежи по-големи от",
  "alerts.precipitationGreaterThanThreshold": "Часови валежи над прага от {value}{unit}",
  "alerts.pressureGreaterThan": "Налягане по-високо от",
  "alerts.pressureGreaterThanThreshold": "Налягане по-високо от {value}{unit}",
  "alerts.pressureLessThan": "Налягане по-ниско от",
  "alerts.pressureLessThanThreshold": "Налягане по-ниско от {value}{unit}",
  "alerts.rainRateGreaterThan": "Интензивност на дъжда по-голяма от",
  "alerts.rainRateGreaterThanThreshold": "Интензивност на дъжда над прага от {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Слънчево излъчване по-високо от",
  "alerts.solarRadiationGreaterThanThreshold": "Слънчево излъчване по-високо от {value}{unit}",
  "alerts.solarRadiationLessThan": "Слънчево излъчване по-ниско от",
  "alerts.solarRadiationLessThanThreshold": "Слънчево излъчване по-ниско от {value}{unit}",
  "alerts.stormChartUnavailable": "Няма налична история на валежите за този дъжд.",
  "alerts.stormDetail": "Обобщение на дъжда",
  "alerts.stormDuration": "Продължителност",
  "alerts.stormEnd": "Край",
  "alerts.stormPeakRate": "Максимална интензивност на дъжда",
  "alerts.stormStart": "Начало",
  "alerts.stormTotal": "Общо валежи",
  "alerts.temperatureGreaterThan": "Температура по-висока от",
  "alerts.temperatureGreaterThanThreshold": "Температура по-висока от {value}{unit}",
  "alerts.temperatureLessThan": "Температура по-ниска от",
  "alerts.temperatureLessThanThreshold": "Температура по-ниска от {value}{unit}",
  "alerts.thswGreaterThan": "THSW по-голям от",
  "alerts.thswGreaterThanThreshold": "THSW по-голям от прага на {value}{unit}",
  "alerts.thswLessThan": "THSW по-малък от",
  "alerts.thswLessThanThreshold": "THSW по-малък от прага на {value}{unit}",
  "alerts.thwGreaterThan": "THW по-голям от",
  "alerts.thwGreaterThanThreshold": "THW по-голям от прага на {value}{unit}",
  "alerts.thwLessThan": "THW по-малък от",
  "alerts.thwLessThanThreshold": "THW по-малък от прага на {value}{unit}",
  "alerts.triggerHistory": "История на предупреждението",
  "alerts.uvGreaterThan": "UV индекс по-висок от",
  "alerts.uvGreaterThanThreshold": "UV индекс по-вискок от {value}{unit}",
  "alerts.uvLessThan": "UV индекс по-нисък от",
  "alerts.uvLessThanThreshold": "UV индекс по-нисък от {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видимост, над праг от {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видимост, под праг от {value}{unit}",
  "alerts.visiblityGreaterThan": "Видимост над",
  "alerts.visiblityLessThan": "Видимост под",
  "alerts.whichMeasure": "За кое измерване искате да бъдете сигнализирани?",
  "alerts.whichModule": "За кой модул бихте искали да бъдете сигнализирани?",
  "alerts.windChillGreaterThan": "Wind Chill по-голям от",
  "alerts.windChillGreaterThanThreshold": "Wind Chill по-голям от прага на {value}{unit}",
  "alerts.windChillLessThan": "Wind Chill по-малък от",
  "alerts.windChillLessThanThreshold": "Wind Chill по-малък от прага на {value}{unit}",
  "alerts.windSpeedGreaterThan": "Скорост на вятъра над",
  "alerts.windSpeedGreaterThanThreshold": "Скорост на вятъра над прага на {value}{unit}",
  "alerts.windSpeedLessThan": "Скорост на вятъра под",
  "alerts.windSpeedLessThanThreshold": "Скорост на вятъра под прага на {value}{unit}",
  "astral.astronomicalSunPhase": "Астрономически {sunPhase}",
  "astral.civilSunPhase": "Граждански {sunPhase}",
  "astral.dawn": "Разсъмване",
  "astral.dusk": "Здрачаване",
  "astral.firstQuarter": "Първа четвърт",
  "astral.fullMoon": "Пълнолуние",
  "astral.lastQuarter": "Последна четвърт",
  "astral.moon": "Луна",
  "astral.moonPhases": "Лунни фази",
  "astral.moonrise": "Изгрев на Луната",
  "astral.moonset": "Залез на Луната",
  "astral.nauticalSunPhase": "Морски {sunPhase}",
  "astral.newMoon": "Новолуние",
  "astral.noon": "Пладне",
  "astral.remainingDaylight": "Оставаща част от деня",
  "astral.sunrise": "Изгрев",
  "astral.sunriseAndSunset": "Изгрев и залез",
  "astral.sunriseAt": "Изгрев в {time}",
  "astral.sunset": "Залез",
  "astral.sunsetAt": "Залез в {time}",
  "astral.totalDaylight": "Продължителност на деня",
  "astral.waningCrescent": "Залязващ полумесец",
  "astral.waningGibbous": "Намаляваща Луна",
  "astral.waxingCrescent": "Нарастващ полумесец",
  "astral.waxingGibbous": "Нарастваща Луна",
  "auth.alreadyHaveAccount": "Вече имате акаунт?",
  "auth.authContainerTagline": "Вашето лично табло за времето. Свържете станциите си и получавайте данни в реално време на една ръка разстояние.",
  "auth.backToLogin": "Обратно към входа",
  "auth.catchPhrase": "Платформата за метеорологични наблюдения",
  "auth.checkYourEmail": "Проверете имейла си",
  "auth.continueWithApple": "Продължете с Apple",
  "auth.continueWithFacebook": "Продължете с Facebook",
  "auth.continueWithGoogle": "Продължете с Google",
  "auth.email": "Имейл адрес",
  "auth.emailRequiredLoginFacebook": "Изисква се разрешение за имейл.",
  "auth.emailVerification": "Потвърждение на имейла",
  "auth.emailVerificationFailure": "Възникна проблем с потвърждението на вашия имейл.",
  "auth.emailVerificationSuccess": "Вашият имейл е потвърден успешно.",
  "auth.firstName": "Име",
  "auth.forgotPassword": "Забравена парола?",
  "auth.forgotPasswordSubtitle": "Въведете имейла си и ще ви изпратим връзка за нулиране на паролата.",
  "auth.lastName": "Фамилия",
  "auth.login": "Вход",
  "auth.loginSubtitle": "Добре дошли отново! Моля, въведете вашите данни.",
  "auth.loginToSmartMixinDescription": "Въведете своите идентификационни данни в SmartMixin за достъп до вашия акаунт.",
  "auth.logout": "Изход",
  "auth.logoutConfirmation": "Сигурни ли сте, че искате да излезете?",
  "auth.noAccountYet": "Все още нямате акаунт?",
  "auth.or": "или",
  "auth.password": "Парола",
  "auth.passwordAgain": "Повторете паролата",
  "auth.passwordReset": "Нулиране на парола",
  "auth.passwordResetSuccess": "Вашата парола е актуализирана успешно.",
  "auth.register": "Създайте акаунт",
  "auth.registerDescription": "Създайте безплатен акаунт в SmartMixin, за да свържете метеорологичните си станции, да проследявате метеорологични данни и да получите достъп до мощни аналитични инструменти.",
  "auth.registerSubtitle": "Създайте акаунта си, за да започнете.",
  "auth.registerSuccess": "Регистрирахте се успешно! Изпратихме ви връзка за потвърждение на {emailAddress} с допълнителни инструкции.",
  "auth.restorePassword": "Възстановяване на парола",
  "auth.restorePasswordSuccess": "Изпратихме ви връзка за нулиране на парола на {emailAddress} с допълнителни инструкции.",
  "auth.sendReset": "Изпратете инструкции за нулиране",
  "auth.signInWithApple": "",
  "auth.socialAccount": "или използвайте акаунта си",
  "auth.welcome": "Добре дошли в SmartMixin",
  "auth.welcomeBack": "Добре дошли отново!",
  "calendar.april": "Април",
  "calendar.august": "Август",
  "calendar.dateFormat": "Формат на датата",
  "calendar.day": "Ден",
  "calendar.december": "Декември",
  "calendar.end": "Край",
  "calendar.february": "Февруари",
  "calendar.hours": "Часове",
  "calendar.hoursShort": "Часове съкратено",
  "calendar.january": "Януари",
  "calendar.july": "Юли",
  "calendar.june": "Юни",
  "calendar.last24Hours": "последните 24 часа",
  "calendar.last30Days": "последните 30 дни",
  "calendar.last7Days": "последните 7 дни",
  "calendar.march": "Март",
  "calendar.max": "Максимално",
  "calendar.may": "Май",
  "calendar.month": "Месец",
  "calendar.months": "месеци",
  "calendar.november": "Ноември",
  "calendar.october": "Октомври",
  "calendar.oneDay": "1-ден",
  "calendar.oneHour": "1-час",
  "calendar.oneMonth": "1-месец",
  "calendar.oneWeek": "1-седмица",
  "calendar.previous24Hours": "Предходните 24 часа",
  "calendar.previous30Days": "Предходните 30 дни",
  "calendar.previous7Days": "Предходните 7 дни",
  "calendar.previousDay": "Вчера",
  "calendar.previousMonth": "Миналия месец",
  "calendar.previousWeek": "Миналата седмица",
  "calendar.previousYear": "Миналата година",
  "calendar.sameDayLastYear": "На този ден през миналата година",
  "calendar.sameMonthLastYear": "През този месец миналата година",
  "calendar.selectADate": "Изберете дата",
  "calendar.selectAggregation": "Изберете показвана стойност",
  "calendar.selectAMonth": "Изберете месец",
  "calendar.selectAYear": "Изберете година",
  "calendar.selectGranularity": "Изберете детайлност",
  "calendar.selectTimescale": "Изберете времева скала",
  "calendar.september": "Септември",
  "calendar.sixHours": "6-часа",
  "calendar.start": "Начало",
  "calendar.thirtyMinutes": "30-минути",
  "calendar.threeHours": "3-часа",
  "calendar.use24HourFormat": "Използвайте 24-часов формат",
  "calendar.week": "Седмица",
  "calendar.year": "Година",
  "calendar.yesterday": "Вчера",
  "common.accountDeleted": "Вашият акаунт беше изтрит успешно.",
  "common.accountOnHold": "Връзката на вашия акаунт е изтекла. Моля, свържете се отново, за да възобновите актуализациите на данните.",
  "common.add": "Добавете",
  "common.addAStation": "Добавете станция",
  "common.addToFavorites": "Добавете към любими",
  "common.addYourOwnStation": "Добавете своята станция",
  "common.alreadyPremium": "Вече имате премиум акаунт!",
  "common.alsoAvailableOn": "Налично също в:",
  "common.altitude": "Надморска височина",
  "common.analysis": "Анализи",
  "common.aroundMe": "Около мен",
  "common.articleCount": "{count, plural, one {# статия} other {# статии}}",
  "common.articleNotFound": "Статията не е намерена",
  "common.articleNotFoundDescription": "Статията, която търсите, не съществува.",
  "common.average": "Средни стойности",
  "common.averageOverThePeriod": "Средни стойности за периода",
  "common.away": "Отдалеченост",
  "common.back": "Назад",
  "common.backToHelpCenter": "Обратно към помощния център",
  "common.backToHome": "Обратно към Началото",
  "common.bad": "Лошо",
  "common.batteryLevel": "Ниво на батерията",
  "common.bestValue": "Най-добра Стойност",
  "common.billingDetailsAndroid": "За периода на безплатния пробен период няма да бъдете таксувани, ако анулирате 24 часа преди изтичането на безплатния период. Когато пробният период приключи, можете да анулирате абонамента за SmartMixin по всяко време чрез настройките на вашия акаунт в Google Play или той ще бъде автоматично подновен. Това трябва да се направи 24 часа преди края на абонаментния период, за да се избегне начисляването на друга такса, показана в бутона по-горе. Плащанията за абонамент ще бъдат таксувани от вашия акаунт в Google Play след потвърждение на вашата покупка и при започване на всеки срок за подновяване.",
  "common.billingDetailsIos": "За периода на безплатния пробен период няма да бъдете таксувани, ако анулирате 24 часа преди изтичането на безплатния период. Когато пробният период приключи, можете да анулирате абонамента за SmartMixin по всяко време чрез настройките на вашия акаунт в App Store или той ще бъде автоматично подновен. Това трябва да се направи 24 часа преди края на абонаментния период, за да се избегне начисляването на друга такса, показана в бутона по-горе. Плащанията за абонамент ще бъдат таксувани от вашия акаунт в App Store след потвърждение на вашата покупка и при започване на всеки срок за подновяване.",
  "common.boilerOn": "Нагревател ВКЛ",
  "common.browseByCategory": "Преглед по категория",
  "common.calendarView": "Изглед на календара",
  "common.cancel": "Отказ",
  "common.cannotBeEmpty": "Това поле не може да бъде празно.",
  "common.cardDetails": "Данни за картата",
  "common.categoryNotFound": "Категорията не е намерена",
  "common.categoryNotFoundDescription": "Тази категория не съществува или няма статии.",
  "common.charts": "Графики",
  "common.chartView": "Графичен изглед",
  "common.clearRecentLocations": "Изчистете всички",
  "common.close": "Затвори",
  "common.comparison": "Сравнение",
  "common.contactMe": "Свържете се с мен",
  "common.currentDay": "Днес",
  "common.currentLocation": "Текущо местоположение",
  "common.currentObservations": "Текущи наблюдения",
  "common.currentRainEvent": "Текущо дъждовно събитие",
  "common.currentRate": "Интензивност на дъжда",
  "common.currentWeatherConditions": "Текущи условия",
  "common.customizeComparisonMetrics": "Персонализиране на показателите за сравнение",
  "common.customizeComparisonMetricsDescription": "Плъзнете елементите, за да пренаредите показателите за сравнение. Докоснете иконата с око, за да покажете или скриете показателите.",
  "common.customizeDashboard": "Персонализиране",
  "common.customizeDashboardDescription": "Плъзнете елементите, за да пренаредите таблото. Докоснете иконата с око, за да покажете или скриете секции.",
  "common.customizedStationName": "Персонализирано име на станция",
  "common.dailyForecast": "Дневна прогноза",
  "common.dashboard": "Панел",
  "common.default": "По подразбиране",
  "common.defaultForecastModelChip": "По подразбиране · {name}",
  "common.delete": "Изтрийте",
  "common.deleteAccount": "Изтриване на вашия акаунт",
  "common.deleteAccountConfirmation": "Сигурни ли сте, че искате да изтриете акаунта си? Това действие е необратимо.",
  "common.deleteAccountDescription": "Това действие изтрива вашия акаунт и цялата ви информация. Няма връщане назад.",
  "common.details": "Детайли",
  "common.edit": "Редактирайте",
  "common.editor": "Редактор",
  "common.endTime": "КРАЙ",
  "common.exitFullscreen": "Изход от цял екран",
  "common.exploreWeatherMap": "Разгледайте Картата на Времето",
  "common.favoriteLocations": "Любими",
  "common.favoriteLocationsEmpty": "Можете да добавите до 5 любими места.",
  "common.favoriteStations": "Любими станции",
  "common.feedbackHelpsImprove": "Вашето мнение ни помага да подобрим помощните статии.",
  "common.feedbackReasonNotAnswer": "Не отговаря на въпроса ми",
  "common.feedbackReasonOutdated": "Информацията е остаряла",
  "common.feedbackReasonUnclear": "Инструкциите са неясни",
  "common.feedbackWhatWentWrong": "Какъв беше проблемът?",
  "common.filterStationDescription": "Не показвайте станции с ненадеждни измервания",
  "common.filterStations": "Филтрирайте станции",
  "common.filterStationSourceDescription": "Изберете доставчици на станции, които искате да покажете на картата",
  "common.findStationsNearYou": "Намерете станции наблизо",
  "common.firmwareVersion": "Версия на фърмуера",
  "common.forecast": "Прогноза",
  "common.forecastComparisonDescription": "Сравнете детайлите от моделите на прогнозата от няколко източника",
  "common.forecastModelComparison": "Сравнение на прогнозните модели",
  "common.forecastModelCoverage": "Покритие",
  "common.forecastModelDescription": "Описание",
  "common.forecastModelDescription_AROME": "Високорезолюционният модел на Météo France, позволяващ разрешаване на конвекция, над Западна Европа с резолюция 1,3 км. Най-добрият в класа си за краткосрочни прогнози във Франция; обновява се на всеки три часа.",
  "common.forecastModelDescription_ARPEGE_EU": "Европейският нест на модела ARPEGE на Météo France с резолюция 10 км. Средносрочни прогнози над Европа, обновявани четири пъти дневно.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Глобалният числен модел за прогноза на времето на Météo France с резолюция 25 км, до около 4 дни. Обновява се четири пъти дневно.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI на DMI: модел, допускащ конвекция, над северозападна Европа — Дания, Бенелюкс, Ирландия, Обединеното кралство и Скандинавия — с резолюция 2 км до 60 часа, обновяван осем пъти дневно. Съдържа модифицирани отворени данни на DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Глобалната детерминистична прогнозна система на Environment Canada: световен средносрочен модел с резолюция 15 км до 10 дни, обновяван два пъти дневно.",
  "common.forecastModelDescription_EC_HRDPS": "Високоразделителната детерминистична прогнозна система на Environment Canada: модел, допускащ конвекция, над Канада и северната част на САЩ с резолюция 2,5 км до 48 часа, обновяван четири пъти дневно.",
  "common.forecastModelDescription_EC_RDPS": "Регионалната детерминистична прогнозна система на Environment Canada: средносрочен модел над Северна Америка с резолюция 10 км, обновяван четири пъти дневно.",
  "common.forecastModelDescription_ECMWF_HRES": "Флагманският модел с висока разделителна способност (IFS) на Европейския център за средносрочни прогнози на времето, широко смятан за водещата глобална прогнозна система в света. Покрива цялата планета с разделителна способност 25 км до 15 дни, обновяван четири пъти дневно. Съдържа модифицирани отворени данни на ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Водещият глобален модел със среден обхват на NOAA. Покрива цялата планета с резолюция 25 км до 16 дни, обновява се четири пъти дневно.",
  "common.forecastModelDescription_HRRR_CONUS": "Високорезолюционното бързо обновяване на NOAA: модел, позволяващ разрешаване на конвекция, над континентална САЩ с резолюция 3 км, обновяван всеки час. Най-подходящ за много краткосрочни прогнози на гръмотевични бури и тежки атмосферни условия.",
  "common.forecastModelDescription_ICON": "Глобалният модел ICON на DWD с разделителна способност 13 km, покриващ цялата планета до 7,5 дни, обновяван четири пъти дневно. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I на ItaliaMeteo, разработван съвместно с ARPAE: модел, допускащ конвекция, над Италия с резолюция 2,2 км до 72 часа, обновяван два пъти дневно. Съдържа отворени данни на ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Контролният цикъл на ICON-CH1-EPS на MeteoSwiss: модел, допускащ конвекция, над Алпите с резолюция 1 км до 33 часа, обновяван на всеки три часа.",
  "common.forecastModelDescription_ICON_CH2": "Контролният цикъл на ICON-CH2-EPS на MeteoSwiss: модел, допускащ конвекция, над Алпите — Швейцария и околния алпийски регион — с резолюция 2,1 км до 120 часа, обновяван четири пъти дневно.",
  "common.forecastModelDescription_ICON_DE": "Високорезолюционният модел на DWD, позволяващ разрешаване на конвекция, над Германия и съседните страни с резолюция 2,2 км. Краткосрочни прогнози, обновявани два пъти дневно. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Европейският нест на модела ICON на DWD с резолюция 7 км, покриващ Европа и Северния Атлантик. Средносрочни прогнози, обновявани четири пъти дневно. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Откритата услуга за прогноза на времето на Норвежкия метеорологичен институт, която съчетава скандинавски модели с висока резолюция с данни от ECMWF за предоставяне на глобални прогнози до 10 дни напред.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Нест AROME над френските Антили (Гваделупа, Мартиника) с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Нест AROME над френска Гвиана с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Нест AROME над Нова Каледония с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Нест AROME над френска Полинезия с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Нест AROME над Реюнион и Майот с резолюция 2,5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "common.forecastModelDescription_NAM_CONUS": "Севернамериканският мезомащабен модел нест на NOAA над континентална САЩ с резолюция 5 км. Краткосрочни прогнози, обновявани четири пъти дневно.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Севернамериканският мезомащабен модел на NOAA, покриващ цяла Северна Америка с резолюция 32 км. Обновява се четири пъти дневно.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Водещата прогноза на SmartMixin. За всеки час на вашето местоположение избираме най-добрия наличен модел — обикновено високорезолюционен регионален модел, където такъв съществува (AROME във Франция, ICON-D2 в Германия, HRRR в САЩ, ARPEGE Europe в континента…) и преминаваме към глобален модел другаде — след което попълваме всички пропуски от съседни източници. Резултатът е една безпроблемна прогноза, покриваща навсякъде по света до 14 дни, автоматично обновявана всеки път, когато някой от базовите модели се актуализира.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Собствената глобална прогноза на Weatherflow, която смесва множество числени модели за времето с наблюдения от своята мрежа от метеорологични станции Tempest. 10-дневен световен хоризонт.",
  "common.forecastModelDetailTitle": "Прогнозен модел",
  "common.forecastModelScopeGlobal": "Глобален",
  "common.forecastModelScopeGlobalDescription": "Този модел обхваща цялата планета.",
  "common.forecastModelScopeRegional": "Регионален",
  "common.forecastModelScopeRegionalDescription": "Този модел обхваща само определен регион.",
  "common.forecastModelSpecifications": "Спецификации",
  "common.forecastSources": "Източници за прогноза",
  "common.freeAccount": "Безплатен акаунт",
  "common.freeSubscription": "Безплатен премиум абонамент",
  "common.freeTrialForPeriod": "Безплатен пробен период за {period} дни",
  "common.frequency": "Честота",
  "common.full": "Пълен",
  "common.fullscreen": "Цял екран",
  "common.getStartedFree": "Започнете Безплатно",
  "common.getUnlimitedAccess": "Неограничен достъп до:",
  "common.good": "Добро",
  "common.hail": "Градушка",
  "common.help": "Помощ",
  "common.helpCategoryAccount": "Акаунт",
  "common.helpCategoryBilling": "Фактуриране",
  "common.helpCategoryGettingStarted": "Първи стъпки",
  "common.helpCategoryProviders": "Доставчици",
  "common.helpCategoryStations": "Станции",
  "common.helpCategoryTroubleshooting": "Отстраняване на проблеми",
  "common.helpCenter": "Помощен център",
  "common.helpCenterDescription": "Намерете отговори на често задавани въпроси и научете как да извлечете максимума от SmartMixin.",
  "common.hg": "Защита от замръзване",
  "common.hidden": "Скрити",
  "common.hiddenSensors": "Скрити сензори",
  "common.hiddenStations": "Скрити станции",
  "common.hiddenStationsDescription": "Можете да покажете отново станция, като докоснете иконата с око до нея.",
  "common.high": "Висок",
  "common.home": "Вкъщи",
  "common.homeConnectService": "Имате метеорологична станция? Свържете услугата си",
  "common.homeInformation": "Информация за дома",
  "common.homeIntroduction": "Свържете вашите външни акаунти, за да се насладите на функциите на SmartMixin.",
  "common.homeName": "Име за вкъщи",
  "common.homeSubtitle": "Вашето време, всичко на едно място",
  "common.horizon": "Хоризонт",
  "common.horizonValue": "до {value} часа",
  "common.iDontKnowYet": "не съм решил",
  "common.indoor": "В помещението",
  "common.lastRainEvent": "Последно дъждовно събитие",
  "common.lastUpdate": "Последна актуализация",
  "common.legendHeavy": "Силен",
  "common.legendLight": "Слаб",
  "common.legendLightningHelp": "Цветът показва възрастта на всяка мълния през последните {minutes} минути — най-новите в бяло, най-старите в тъмночервено.",
  "common.legendNewest": "Най-нови",
  "common.legendOldest": "Най-стари",
  "common.legendStationsHelp": "Цветът на маркера отразява стойността на избрания показател.",
  "common.lightningDataAttribution": "Данни за мълнии: Blitzortung.org",
  "common.lightningStrikes": "Мълнии",
  "common.lightningStrikesDescription": "Показване на мълниите в реално време върху картата",
  "common.linkToSection": "Връзка към този раздел",
  "common.loading": "Зареждане",
  "common.location": "Местоположение",
  "common.locationAddedToFavorites": "Местоположение, добавено към любимите",
  "common.locationNotGranted": "Разрешението за местоположение не се предоставя. Моля, разрешете достъп до вашето местоположение в настройките на устройството.",
  "common.locationRemovedFromFavorites": "Местоположение, отстранено от любими",
  "common.locations": "Местоположения",
  "common.low": "Нисък",
  "common.manage": "Управление",
  "common.manageAccount": "Управление на акаунта",
  "common.manageMySubscription": "Управление на абонамента",
  "common.manageSensors": "Управление на сензори",
  "common.manageSensorsDescription": "Плъзнете елементите, за да пренаредите сензорите. Докоснете иконата с око, за да покажете или скриете сензори. Докоснете името, за да го преименувате.",
  "common.manualBoost": "Ръчно усилване",
  "common.manualSetpointUntil": "Ръчна настройка до",
  "common.mapLayers": "Слоеве на картата",
  "common.mapLegend": "Легенда на картата",
  "common.maxFavoriteLocationsReached": "Можете да имате само до 5 любими места. Извадете един, за да добавите друг.",
  "common.maximum": "Максимум",
  "common.measureToDisplay": "Измерете за показване",
  "common.medium": "Средно",
  "common.meshSize": "Размер на мрежата",
  "common.minimum": "Минимум",
  "common.minRead": "{minutes} мин четене",
  "common.modifyFavoriteStations": "Променете любимите станции",
  "common.modifyFavoriteStationsDescription": "Можете да пренаредите любимите си станции, като ги плъзнете. Можете също да ги премахнете от списъка.",
  "common.moduleType": "Тип модул",
  "common.monthTotal": "Този месец",
  "common.more": "Повече",
  "common.moreInformation": "Повече информация",
  "common.myLocation": "Моето местоположение",
  "common.nearbyWeatherStations": "Наблизо метеорологични станции",
  "common.next": "След това",
  "common.nextHours": "През следващите часове",
  "common.no": "Не",
  "common.noAccountNeeded": "Не е необходим акаунт",
  "common.noDataForThisPeriod": "Няма данни за този период",
  "common.noLocationsFound": "Няма намерени места",
  "common.noNetatmoWeatherStationYet": "Все още нямате метеорологична станция Netatmo.",
  "common.noOutdoorModule": "Няма функционален външен модул за тази станция.",
  "common.noSearchResults": "Няма статии, отговарящи на търсенето ви",
  "common.noStationsFound": "Не са намерени станции",
  "common.noThermostatYet": "Все още нямате термостат.",
  "common.notNow": "Не сега",
  "common.notPurchasedYet": "Изглежда това все още не е закупено.",
  "common.noWeatherStation": "Няма метеорологична станция",
  "common.noWeatherStationYet": "Все още нямате метеорологична станция.",
  "common.numberOfActiveWarnings": "{warning_count} Активни метеорологични предупреждения",
  "common.onThisPage": "На тази страница",
  "common.openSettings": "Отворени настройки",
  "common.orChooseMonthly": "Или избери месечно:",
  "common.outdatedModule": "Данните за този модул не са актуални.",
  "common.outdoor": "Отвън",
  "common.outdoorTemperature": "Външна температура",
  "common.pageNotFound": "Страницата Не е Намерена",
  "common.pageNotFoundDescription": "Страницата, която търсите, не съществува или е преместена.",
  "common.passwordUpdated": "Паролата е актуализирана успешно.",
  "common.personalWeatherIntelligence": "Вашият Личен Метеорологичен Интелект",
  "common.platformMobileApp": "Мобилно приложение",
  "common.platformMobileOnly": "Само в мобилното приложение",
  "common.platformWebApp": "Уеб приложение",
  "common.platformWebOnly": "Само в уеб приложението",
  "common.popularArticles": "Популярни статии",
  "common.premiumAccount": "Премиум акаунт",
  "common.premiumDescription": "Премиум абонаментът отключва много допълнителни функции като усъвършенстван анализ на времето, сравнения на диаграми, регионални прогнозни модели и много други.",
  "common.premiumFeatureAlerts": "Метеорологични Известия",
  "common.premiumFeatureAnalysis": "Разширен Анализ на Времето",
  "common.premiumFeatureCharts": "Сравнения на Графики",
  "common.premiumFeatureExport": "Експорт на Данни",
  "common.premiumFeatureForecast": "Регионални Прогностични Модели",
  "common.premiumFeatureNotification": "Уиджет на Статус Лентата",
  "common.premiumFeatureTitle": "Премиум Функция",
  "common.premiumFeatureWidgets": "Уиджети на началния екран",
  "common.pressureSummary": "Синтез на налягане",
  "common.previous": "Предишен",
  "common.previousHours": "Предишни часове",
  "common.profileUpdated": "Профилът е актуализиран успешно.",
  "common.purchasedNetatmoPro": "Вече сте закупили Netatmo Pro ({date}). Това ви дава достъп до подгрупа от премиум функции. Абонирайте се за една от следните оферти, ако искате да имате достъп до всички премиум функции.",
  "common.radarDataAttribution": "Данни от радар: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Дъжд",
  "common.rainEvents": "Дъждовни събития",
  "common.rainfallMeasurement": "Измерване на количество валежи",
  "common.rainRadar": "Радар за дъжд",
  "common.rainRadarDescription": "Показване на наслагване на радар за дъжд върху картата",
  "common.rainSummary": "Обобщение на валежите",
  "common.range": "Обхват",
  "common.recentLocations": "Скоро",
  "common.recentLocationsEmpty": "Вие скорошната история е празна.",
  "common.recentStations": "Последно добавени станции",
  "common.relatedArticles": "Свързани статии",
  "common.relay": "Сменете",
  "common.removeFromFavorites": "Премахнете от любими",
  "common.renameSensors": "Преименувайте сензорите",
  "common.resetZoom": "Нулирай мащаба",
  "common.restorePurchase": "Възстановяване на покупката",
  "common.room": "Стая",
  "common.rooms": "Стаи",
  "common.savingsPercent": "Спестявате {percent}%",
  "common.searchArticles": "Търсене на статии...",
  "common.searchForALocation": "Търсене на място...",
  "common.searchForLocation": "Потърсете местоположение",
  "common.searchForWeatherStation": "Потърсете метеорологична станция",
  "common.searchResults": "Резултати от търсенето",
  "common.searchResultsEmpty": "Не са намерени резултати.",
  "common.searchResultsFound": "{count, plural, one {# намерен резултат} other {# намерени резултата}}",
  "common.searchStationsDescription": "Въведете град, адрес или име на място, за да намерите метеорологични станции наблизо.",
  "common.searchStationsHint": "Използвайте лентата за търсене по-горе, за да откриете метеорологични станции навсякъде по света.",
  "common.selectStationForComparison": "Изберете станция за сравнение",
  "common.selectWeatherForecastProvider": "Моля, изберете доставчик на прогноза",
  "common.serialNumber": "Сериен номер",
  "common.share": "Споделете",
  "common.shareOutdoorMeasures": "Споделете вашите външни измервания",
  "common.shareOutdoorMeasuresDescription": "Влезте в общността на SmartMixin, като направите външните си измервания видими за другите. Измерванията ви вкъщи никога няма да бъдат споделяни.",
  "common.shareYourWeather": "Споделете вашите измервания на времето",
  "common.signalStrength": "Сила на сигнала",
  "common.skip": "Пропуснете",
  "common.smartThermostat": "Интелигентен термостат",
  "common.smartValve": "Интелигентен клапан",
  "common.snow": "Сняг",
  "common.start": "Започнете",
  "common.startFreeTrial": "Започнете Безплатен Пробен Период",
  "common.startTime": "Начало",
  "common.station": "станция",
  "common.stationAddedToFavorites": "Станцията е добавена към любими",
  "common.stationComparison": "Сравнение на станции",
  "common.stationComparisonDescription": "Сравнете минали данни за времето с друга станция",
  "common.stationInformation": "Информация за станцията",
  "common.stationName": "Име на станцията",
  "common.stationObservationsDescription": "Показване на последните наблюдения от метеорологичните станции",
  "common.stationRemovedFromFavorites": "Станцията е премахната от любимите",
  "common.stations": "станции",
  "common.stationsNear": "Станции близо до",
  "common.stationType": "Тип станция",
  "common.statusOffline": "Офлайн",
  "common.statusOnline": "Онлайн",
  "common.statusStale": "Остаряло",
  "common.statusSyncing": "Синхронизиране",
  "common.stillNeedHelp": "Все още се нуждаете от помощ?",
  "common.stillNeedHelpDescription": "Ако тази статия не отговори на въпроса ви, с удоволствие ще ви помогна лично.",
  "common.subscribeNow": "Абонирай се сега - без пробен период",
  "common.sumOverThePeriod": "Натрупано през периода",
  "common.switchToPremium": "Преминете към SmartMixin Premium",
  "common.temperatureShort": "Темп.",
  "common.temperatureSummary": "Обобщение на температурата",
  "common.thankYouForFeedback": "Благодарим ви за обратната връзка!",
  "common.thenPrice": "след това {price}",
  "common.timeSelection": "Избор на време",
  "common.timezone": "Часова зона",
  "common.totalDuration": "Обща продължителност",
  "common.tryAnotherLocation": "Не намерихме метеорологични станции близо до това място. Опитайте да търсите в друг район.",
  "common.unknown": "Неизвестно",
  "common.untilChanged": "До промяна",
  "common.untilTime": "До {time}",
  "common.updateAvailable": "Налична е актуализация",
  "common.updateAvailableOpenAppStore": "Докоснете, за да отворите App Store",
  "common.updateAvailableOpenGooglePlay": "Докоснете, за да отворите Google Play",
  "common.updateAvailableVersion": "Налична е актуализация: v{version}",
  "common.upgrade": "Надстройка",
  "common.upgradeRequiredAndroid": "Изисква се нова версия на вашето приложение. Посетете Google Play, за да надстроите.",
  "common.upgradeRequiredIos": "Изисква се нова версия на вашето приложение. Посетете App Store, за да надстроите.",
  "common.validate": "Валидирайте",
  "common.validEmail": "Изисква се валиден имейл адрес.",
  "common.very_low": "Много ниско",
  "common.visitNetatmoWebsite": "Посетете уебсайта на Netatmo",
  "common.wasArticleHelpful": "Полезна ли беше тази статия?",
  "common.weatherCondition": "Метеорологични условия",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain е допълнителен източник на данни, предоставен чрез Tempest Weather System, захранван от Nearcast Technology. NC Rain данните са оценка на средното натрупване на валежи около вашия Tempest на ниво квартал",
  "common.weatherForecastModels": "Модели за прогноза на времето",
  "common.weatherIntelligencePlatform": "Платформата за Метеорологичен Интелект",
  "common.weatherMap": "Метеорологична карта",
  "common.weatherMapMetaDescription": "SmartMixin предлага интерактивни карти на времето и радара за метеорологични условия по целия свят.",
  "common.weatherObservations": "Наблюдения за времето",
  "common.weatherStation": "Метеорологична станция",
  "common.weatherStations": "Метеорологични станции",
  "common.welcome": "Добре дошли в SmartMixin!",
  "common.whenBackHome": "Кога ще се приберете у дома?",
  "common.wifiStrength": "Сила на безжичната връзка",
  "common.wind": "Вятър",
  "common.windMeasurement": "Измерване на вятъра",
  "common.windSpeed": "Скорост на вятъра",
  "common.windSummary": "Синтез на вятъра",
  "common.yearToDate": "Тази година",
  "common.yes": "Да",
  "common.zoomImage": "Увеличаване на изображението",
  "forecastMaps.addColor": "Добавяне на цвят",
  "forecastMaps.addLayer": "Добавяне на слой",
  "forecastMaps.autoPreview": "Авто",
  "forecastMaps.backToMaps": "Назад към картите",
  "forecastMaps.browseMaps": "Разглеждане на картите",
  "forecastMaps.build": "Генериране",
  "forecastMaps.buildCompleted": "Генерирането завърши",
  "forecastMaps.builderMetaDescription": "Съставете собствени прогнозни карти от слоевете на метеорологичните модели.",
  "forecastMaps.builderTitle": "Създател на карти",
  "forecastMaps.buildFailed": "Генерирането се провали. Опитайте отново.",
  "forecastMaps.buildNotPossible": "Тази карта още не може да бъде генерирана — няма налични прогнозни данни.",
  "forecastMaps.buildProgress": "Изчертаване… {completed}/{total} стъпки",
  "forecastMaps.buildStarting": "Стартиране на генерирането…",
  "forecastMaps.byModel": "По модел",
  "forecastMaps.byZone": "По зона",
  "forecastMaps.colormap": "Цветова скала",
  "forecastMaps.colormapCustom": "Персонализирани цветове",
  "forecastMaps.colormapGroupDomain": "Метеорологични шаблони",
  "forecastMaps.colormapGroupMatplotlib": "Научни шаблони",
  "forecastMaps.colorScale": "Цветова скала",
  "forecastMaps.comingSoon": "Този изглед предстои скоро.",
  "forecastMaps.contourLevels": "Нива на изолиниите",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Франция",
  "forecastMaps.countryGermany": "Германия",
  "forecastMaps.countryItaly": "Италия",
  "forecastMaps.countryScandinavia": "Скандинавия",
  "forecastMaps.countrySpain": "Испания",
  "forecastMaps.countrySwitzerland": "Швейцария",
  "forecastMaps.countryUnitedStates": "Съединени щати",
  "forecastMaps.customColormapMinColors": "Персонализираната цветова скала изисква поне два цвята",
  "forecastMaps.customExtent": "Персонализиран обхват",
  "forecastMaps.deleteMap": "Изтриване на картата",
  "forecastMaps.deleteMapBody": "„{name}“ и нейните изчертавания ще бъдат изтрити завинаги.",
  "forecastMaps.deleteMapTitle": "Да се изтрие ли тази карта?",
  "forecastMaps.displayName": "Показвано име",
  "forecastMaps.downloadMp4": "Изтегли MP4",
  "forecastMaps.downscaling": "Коефициент на разреждане на ветровите флагчета",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Очертаване на област",
  "forecastMaps.east": "Изток",
  "forecastMaps.editMap": "Редактиране на картата",
  "forecastMaps.exportBuilding": "Подготовка на видеото…",
  "forecastMaps.exportError": "Експортирането на видеото не успя. Опитайте отново.",
  "forecastMaps.exportMp4": "Експортирай MP4",
  "forecastMaps.exportNotReady": "Видеото още не е готово. Опитайте отново по-късно.",
  "forecastMaps.extentDrawHint": "Плъзнете върху картата, за да очертаете областта",
  "forecastMaps.extentInvalid": "Западът трябва да е по-малък от изтока, а югът — по-малък от севера",
  "forecastMaps.extentPanZoomHint": "Местете и мащабирайте, докато областта запълни рамката",
  "forecastMaps.flipbookView": "Анимация",
  "forecastMaps.forecastModel": "Прогнозен модел",
  "forecastMaps.forkAndEdit": "Дублиране и редактиране",
  "forecastMaps.height": "Височина (инчове)",
  "forecastMaps.hourOffset": "+{hour} ч",
  "forecastMaps.invalidHexColor": "Невалиден цвят — използвайте #RRGGBB",
  "forecastMaps.layers": "Слоеве",
  "forecastMaps.layerTypeBarbs": "Ветрови флагчета",
  "forecastMaps.layerTypeContour": "Изолинии",
  "forecastMaps.layerTypeFilledContour": "Запълнени изолинии",
  "forecastMaps.layerTypeMagnitude": "Магнитуд",
  "forecastMaps.layerTypeRaster": "Растер",
  "forecastMaps.layerTypeVectorField": "Векторно поле",
  "forecastMaps.leave": "Изход",
  "forecastMaps.levelsCount": "Брой",
  "forecastMaps.levelsInvalid": "Невалидни нива на изолиниите",
  "forecastMaps.levelsModeArange": "Фиксирана стъпка",
  "forecastMaps.levelsModeExplicit": "Изрични стойности",
  "forecastMaps.levelsModeLinspace": "Равномерно разпределени (брой)",
  "forecastMaps.levelsStep": "Стъпка",
  "forecastMaps.levelsValues": "Стойности",
  "forecastMaps.levelsValuesHint": "Разделени със запетаи, възходящо",
  "forecastMaps.localTimeHint": "Показано в местното ви време",
  "forecastMaps.map": "Карта",
  "forecastMaps.mapDescription": "Описание",
  "forecastMaps.mapName": "Име на картата",
  "forecastMaps.mapNameRequired": "Въведете име",
  "forecastMaps.mapSettings": "Настройки на картата",
  "forecastMaps.mapView": "Интерактивна карта",
  "forecastMaps.maxLayersReached": "Тази карта достигна максимума от {max} слоя.",
  "forecastMaps.maxValue": "Максимална стойност",
  "forecastMaps.memoryBudgetExceeded": "Резолюцията надвишава бюджета за изчертаване — намалете DPI или височината",
  "forecastMaps.memoryBudgetUsage": "Бюджет за изчертаване: {percent}%",
  "forecastMaps.metaDescription": "Анимирани прогнозни карти, генерирани от изчисленията на метеорологичните модели.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Изберете величина",
  "forecastMaps.metricUnavailable": "Не е налично за този модел",
  "forecastMaps.minBelowMax": "Минимумът трябва да е по-малък от максимума",
  "forecastMaps.minMaxRequired": "Минималната и максималната стойност са задължителни за този тип слой",
  "forecastMaps.minValue": "Минимална стойност",
  "forecastMaps.modelNoRun": "Все още няма завършено изчисление",
  "forecastMaps.moveLayerDown": "Преместване надолу",
  "forecastMaps.moveLayerUp": "Преместване нагоре",
  "forecastMaps.myMaps": "Моите карти",
  "forecastMaps.nanClipToMin": "Ограничаване до минимума",
  "forecastMaps.nanMask": "Маскиране",
  "forecastMaps.nanPolicy": "Липсващи данни",
  "forecastMaps.nanSkip": "Пропускане",
  "forecastMaps.newMap": "Нова карта",
  "forecastMaps.noCompletedRun": "Тази карта още не е генерирана. Проверете отново скоро.",
  "forecastMaps.noLayers": "Още няма слоеве. Добавете слой, за да започнете.",
  "forecastMaps.noMapsAvailable": "Все още няма налични прогнозни карти.",
  "forecastMaps.north": "Север",
  "forecastMaps.opacity": "Непрозрачност",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Възпроизвеждане",
  "forecastMaps.pointValueError": "Прогнозата за тази точка не можа да бъде заредена.",
  "forecastMaps.pointValueLoading": "Зареждане на прогнозата…",
  "forecastMaps.pointValueUnavailable": "Няма данни за този час.",
  "forecastMaps.presets": "Шаблони",
  "forecastMaps.preview": "Преглед",
  "forecastMaps.previewEmptyHint": "Настройте поне един валиден слой, за да се изчертае преглед.",
  "forecastMaps.previewFailed": "Прегледът се провали",
  "forecastMaps.previewHour": "Час на прогнозата",
  "forecastMaps.previewRendering": "Изчертаване на прегледа…",
  "forecastMaps.projection": "Проекция",
  "forecastMaps.projectionLambertConformal": "Конформна на Ламберт",
  "forecastMaps.projectionMercator": "Меркаторова",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографска",
  "forecastMaps.regionEurope": "Европа",
  "forecastMaps.regionNorthAmerica": "Северна Америка",
  "forecastMaps.removeColor": "Премахване на цвета",
  "forecastMaps.removeLayer": "Премахване на слоя",
  "forecastMaps.retry": "Опитай отново",
  "forecastMaps.run": "Изчисление: {run}",
  "forecastMaps.save": "Запазване",
  "forecastMaps.selectExtentOnMap": "Избор на област върху картата",
  "forecastMaps.south": "Юг",
  "forecastMaps.title": "Прогнозни карти",
  "forecastMaps.uMetric": "U-компонент",
  "forecastMaps.unitConversion": "Преобразуване на единици",
  "forecastMaps.unitNone": "Без",
  "forecastMaps.unsavedChangesBody": "Имате незапазени промени. Изход и отхвърляне?",
  "forecastMaps.unsavedChangesTitle": "Незапазени промени",
  "forecastMaps.useCurrentView": "Използване на текущия изглед",
  "forecastMaps.useModelDomain": "Изкл.: използва се цялата област на модела",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величините U и V трябва да са различни",
  "forecastMaps.validTime": "Валидност: {time}",
  "forecastMaps.valueBetween": "Трябва да е между {min} и {max}",
  "forecastMaps.variable": "Променлива",
  "forecastMaps.viewMap": "Преглед на картата",
  "forecastMaps.vMetric": "V-компонент",
  "forecastMaps.west": "Запад",
  "forecastMaps.windAnimation": "Анимация на вятъра",
  "intro.locationDescription": "Активирайте достъп до местоположението, за да получите точни прогнози, съобразени с вашата точна област — без универсални прогнози.",
  "intro.locationTitle": "Прогнози, направени за вас",
  "intro.notificationDescription": "Включете известия, за да получавате навременни предупреждения за промени във времето, които са важни за вас — дъжд, сняг или тежки условия, точно когато трябва да знаете.",
  "intro.notificationsTitle": "Никога не пропускайте промяна във времето",
  "intro.readyDescription": "Насладете се на точни прогнози, реално време метеорологична информация и данни от станции по целия свят — всичко в едно мощно приложение.",
  "intro.readyTitle": "Всичко е готово!",
  "intro.welcomeDescription": "Вземете хиперлокални прогнози от водещи метеорологични агенции — плюс достъп до над 40 000 метеорологични станции по целия свят, за да видите реалните условия, минали и настоящи.",
  "intro.welcomeTitle": "Вашето време, преосмислено",
  "landing.alerts": "Сигнали",
  "landing.alertsDescription": "Създайте свои собствени сигнали и получавайте известия веднага щом бъдат задействани.",
  "landing.featureAlertsDescription": "Задайте персонализирани известия за условия, които ви интересуват—температура, вятър, валежи и още.",
  "landing.featureAlertsTitle": "Интелигентни известия",
  "landing.featureAnalyticsDescription": "Потопете се в данните си с интерактивни графики, сравнения едно до друго и анализ на тенденции извън основните показатели.",
  "landing.featureAnalyticsTitle": "Мощна аналитика",
  "landing.featureExportDescription": "Изтеглете данните си във формат CSV за анализ в Excel, интеграция с други системи или архивиране.",
  "landing.featureExportTitle": "Експорт навсякъде",
  "landing.featureForecastDescription": "Сравнете прогнози от над 10 метеорологични модела, включително GFS, ECMWF, ICON и други, за да видите кой работи най-добре за вашето местоположение.",
  "landing.featureForecastTitle": "Сравнение на прогнози",
  "landing.featureHistoryDescription": "Достъп до исторически данни с почасова, дневна и месечна скала. Експорт в CSV за изследвания или лични архиви.",
  "landing.featureHistoryTitle": "Богата история",
  "landing.featureMultiBrandDescription": "Свържете станции от Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow и други—всичко в едно табло.",
  "landing.featureMultiBrandTitle": "Поддръжка на множество марки",
  "landing.featuresSubtitle": "Проектирано за ентусиасти на времето, които изискват повече от основно приложение за метеорологична станция.",
  "landing.featuresTitle": "Всичко необходимо за анализ на времето",
  "landing.finalCtaButton": "Създайте безплатен акаунт",
  "landing.finalCtaSubtitle": "Присъединете се към хиляди ентусиасти на времето, които се доверяват на SmartMixin за метеорологичните си данни.",
  "landing.finalCtaTitle": "Готови да подобрите вашето метеорологично изживяване?",
  "landing.forecastDescription": "Достъп до някои от най-добрите модели за прогноза за времето и ги сравнете, за да получите собствена представа какво ще бъде времето.",
  "landing.forecasts": "Прогнози",
  "landing.heroCta": "Започнете безплатно",
  "landing.heroDescription": "Свържете множество метеорологични станции от всяка марка, сравнете прогнозни модели и анализирайте данните си с подробни графики и експорти.",
  "landing.heroSecondaryCta": "Вижте функциите",
  "landing.heroTagline": "Всички метеорологични данни. Една платформа.",
  "landing.heroTitle": "Всички метеорологични данни. Една платформа.",
  "landing.pricingFeatureAdvancedMetrics": "Разширени метрики",
  "landing.pricingFeatureAlerts": "Персонализирани известия",
  "landing.pricingFeatureExport": "Експорт на данни (CSV)",
  "landing.pricingFeatureForecastComparison": "Сравнение на прогнози",
  "landing.pricingFeatureForecasts": "Прогнозни модели",
  "landing.pricingFeatureForecastsFreeTier": "1 модел",
  "landing.pricingFeatureForecastsPremiumTier": "Всички модели (10+)",
  "landing.pricingFeatureReports": "Анализи и справки",
  "landing.pricingFeatureStationComparison": "Сравнение на станции",
  "landing.pricingFeatureWidgets": "Уиджети за начален екран",
  "landing.pricingFeatureYearOverYear": "Анализ година по година",
  "landing.pricingFree": "Безплатно",
  "landing.pricingFreeCta": "Започнете",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Най-популярно",
  "landing.pricingPremium": "Премиум",
  "landing.pricingPremiumCta": "Започнете",
  "landing.pricingPremiumDescription": "От 1,99 €/месец — абонирайте се в уеб, App Store или Google Play",
  "landing.pricingSubtitle": "Започнете безплатно, надградете когато имате нужда от повече.",
  "landing.pricingTitle": "Прости, прозрачни цени",
  "landing.smartMixinDescription": "SmartMixin е приложение, което осигурява достъп до вашата метеорологична станция и 40K+ други станции по целия свят. Помага ви да видите и разберете данните за времето.",
  "landing.statBrands": "Поддържани марки",
  "landing.statForecasts": "Прогнозни модели",
  "landing.statStations": "Метеорологични станции",
  "landing.supportedDevices": "Поддържани устройства",
  "landing.supportedDevicesDescription": "В допълнение към станциите от Световната метеорологична организация, SmartMixin поддържа нарастващ брой марки метеорологични станции.",
  "landing.supportedDevicesNote": "Плюс над 40 000 обществени станции от Световната метеорологична организация",
  "landing.supportedDevicesSubtitle": "Свържете метеорологични станции от водещи марки и вижте всички данни на едно място.",
  "landing.supportedDevicesTitle": "Работи с вашите станции",
  "landing.thermostatDescription": "Свържете вашия Netatmo термостат, за да съпоставите модели на отопление с външните условия.",
  "landing.thermostatManufacturers": "Производителите на термостати също се поддържат да свързват отоплението с външните условия.",
  "landing.thermostatTitle": "Интеграция с интелигентен дом",
  "landing.weatherAnalysis": "Анализ на времето",
  "landing.weatherAnalysisDescription": "SmartMixin идва с много визуализация на данни, която ви позволява да анализирате данните за времето.",
  "landing.weatherAssistant": "Вашият асистент за времето",
  "landing.weatherAssistantDescription": "Независимо дали се интересувате от текущи, исторически или прогнозни метеорологични условия, SmartMixin предоставя множество прозрения, когато имате нужда от тях.",
  "landing.weatherForecastModels": "Модели за прогноза на времето",
  "landing.weatherForecastModelsDescription": "SmartMixin осигурява достъп до най-точните модели за прогноза за времето. Можете лесно да сравните техните прогнози и да направите своя собствена идея.",
  "landing.weatherMap": "Карта на времето",
  "landing.weatherMapDescription": "Разгледайте картата и визуализирайте какво е времето навсякъде по света.",
  "network.cancelError": "Заявката е отменена",
  "network.connectionError": "Сървърът не е достъпен",
  "network.networkError": "Няма налична мрежа",
  "network.serverError": "Нещо се обърка...",
  "network.timeoutError": "Времето за изчакване на връзката изтече",
  "network.unknownError": "Неизвестна грешка",
  "providerHints.ambientWeatherApiKey": "Създаден в настройките на вашия акаунт в ambientweather.net.",
  "providerHints.davisApiSecret": "Показва се само веднъж при създаване на V2 API ключа — съхранявайте го на сигурно място.",
  "providerHints.davisV2ApiKey": "От страницата V2 API ключове в weatherlink.com.",
  "providerHints.ecowittApi": "От страницата API на вашия Ecowitt акаунт.",
  "providerHints.ecowittApp": "Ключът на приложението, също от вашия Ecowitt акаунт.",
  "providerHints.myAcuriteCredentialsBanner": "Използвайте имейла и паролата на вашия My AcuRite акаунт — не входа в SmartMixin.",
  "providerHints.myAcuriteEmail": "Имейлът на вашия My AcuRite акаунт — не вашето SmartMixin вход.",
  "providerHints.myAcuritePassword": "Паролата на вашия My AcuRite акаунт.",
  "providerHints.weatherflowToken": "Личен токен от tempestwx.com → настройки → разрешения за данни.",
  "providerHints.wundergroundEditKey": "Използвай друг ключ",
  "providerHints.wundergroundKey": "Дълъг низ от страницата с API ключове на вашия Weather Underground акаунт — не вашата парола за wunderground.com.",
  "providerHints.wundergroundKeyExample": "напр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API ключът е потвърден",
  "providerHints.wundergroundKeyVerifying": "Проверка на ключа…",
  "providerHints.wundergroundNoStationsNearby": "Не са намерени станции в близост до това местоположение. Опитайте да въведете ID на станция директно.",
  "providerHints.wundergroundStationId": "Всеки идентификатор на станция Weather Underground — ваш или публична станция близо до вас.",
  "providerHints.wundergroundStationIdExample": "напр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Получете вашия Ambient Weather API ключ.",
  "providerIntro.davisStep2": "Получете вашия Davis V2 API ключ и API тайна.",
  "providerIntro.ecowittStep2": "Получете вашия Ecowitt API ключ и ключ на приложението.",
  "providerIntro.getStarted": "Започни",
  "providerIntro.myAcuriteStep2": "Използвайте имейла и паролата на съществуващия си My AcuRite акаунт.",
  "providerIntro.netatmoEnergyStep2": "Влезте в Netatmo, когато бъдете подканени — не е необходим API ключ.",
  "providerIntro.netatmoWeatherStep2": "Влезте в Netatmo, когато бъдете подканени — не е необходим API ключ.",
  "providerIntro.signupBanner": "Почти готово — създайте безплатен SmartMixin акаунт, за да свържете {provider}.",
  "providerIntro.step1": "Влезте в своя SmartMixin акаунт (НЕ в {provider}).",
  "providerIntro.step3EmailPassword": "Въведете ги тук.",
  "providerIntro.step3KeyOrToken": "Поставете тук.",
  "providerIntro.step3OAuth": "Разрешете SmartMixin в изскачащия прозорец.",
  "providerIntro.step3Wunderground": "Поставете вашия API ключ, след което изберете близка станция или въведете произволен ID на станция.",
  "providerIntro.title": "Свържи {provider}",
  "providerIntro.weatherflowStep2": "Получете вашия личен Tempest токен.",
  "providerIntro.wundergroundBrowsePublic": "Нямате станция? Разгледайте публичните",
  "providerIntro.wundergroundFindNearby": "Намери станции наблизо",
  "providerIntro.wundergroundOrEnterId": "Или въведи ID на станция",
  "providerIntro.wundergroundStep2": "Получете вашия API ключ за Weather Underground. След това ще можете да свържете всяка станция — ваша или публична.",
  "reports.agroMeteorology": "Агрометеорология",
  "reports.analysis": "Анализи",
  "reports.annualCumulativeRainfallComparison": "Сравнение на годишните кумулативни валежи",
  "reports.annualHeatingDurationComparison": "Сравнение на продължителността на годишното отопление",
  "reports.annualHeatingEfficiency": "Годишна отоплителна ефективност",
  "reports.annualIndoorComparison": "Годишно сравнение за помещение",
  "reports.annualIndoorReport": "Годишен отчет за помещение",
  "reports.annualOutdoorComparison": "Годишно сравнение за външни измервания",
  "reports.annualOutdoorReport": "Годишен отчет за външни измервания",
  "reports.annualReport": "Годишен отчет",
  "reports.annualSolarReport": "Годишен слънчев отчет",
  "reports.annualWaterBalance": "Годишен воден баланс",
  "reports.annualWaterBalanceCarryOver": "Пренасяне от предходната година",
  "reports.annualWaterBalanceDescription": "Водният баланс (опростена версия, използват се само дъжд и евапотранспирация) помага за управление на водоснабдяването",
  "reports.avgHumidity": "Средна влажност",
  "reports.avgMaxTemperature": "Средна стойност на T°max",
  "reports.avgMetric": "Средно – {metric}",
  "reports.avgMinTemperature": "Средна стойност на T°мин",
  "reports.avgPressure": "Средна стойност на налягането",
  "reports.avgTemperature": "Средна температура",
  "reports.climateNormalPeriodOfRecord": "Период на измерване ({years, plural, one {# година} other {# години}})",
  "reports.climateNormals": "Климатични норми",
  "reports.climateNormalStandardLabel": "Стандартна норма ({period})",
  "reports.climateTrendPerDecade": "Тенденция на температурата: {value} на десетилетие за {years, plural, one {# година} other {# години}}",
  "reports.coldestMonthRanking": "Най-студен {month} в историята",
  "reports.comfortable": "Комфортно (45% {lessThan} Влажност ≤ 60%)",
  "reports.cumulativeRainfall": "Кумулативни валежи",
  "reports.cumulativeRainfallDescription": "Проследявайте общото количество валежи, натрупани през избрания период.",
  "reports.dailyMaxRainfall": "Максимално количество валеж за деня",
  "reports.dataExport": "Експортиране на данни",
  "reports.dataExportXlsxFormatDescription": "Експортирайте всички данни на вашата станция във формат Excel (*.xlsx). След като щракнете върху бутона, след няколко минути ще получите имейл с обработените данни.",
  "reports.daysWithFrost": "Дни със слана",
  "reports.daysWithHeavyRain": "Дни със силен дъжд (≥ {threshold})",
  "reports.daysWithoutThaw": "Дни без топене",
  "reports.daysWithStrongFrost": "Дни със силна слана",
  "reports.emailSent": "До вашата пощенска кутия бе изпратен имейл",
  "reports.frostDays": "Мразовити дни",
  "reports.grasslandTemperatureSum": "Температурна сума на пасища",
  "reports.grasslandTemperatureSumDescription": "Ако сумата от {threshold} е надвишена през пролетта, устойчивото начало на вегетацията е достигнато (работи в Европа)",
  "reports.growingDegreeDays": "Градус-дни на растеж",
  "reports.highPressure": "Антициклон (средно налягане ≥ 1013 mbar)",
  "reports.iceDays": "Ледени дни",
  "reports.indoorReport": "Отчет от измервания в помещението",
  "reports.keyFacts": "Ключови факти",
  "reports.longestDrySpell": "Най-дълъг сух период",
  "reports.longestRunOfRainyDays": "Най-дългата серия от дъждовни дни",
  "reports.longestRunWithoutRun": "Дни на суша",
  "reports.longestWetSpell": "Най-дълъг дъждовен период",
  "reports.lowPressure": "Ниско налягане (средно налягане {lessThan} 1013mbar)",
  "reports.maxHumidity": "Максимална влажност",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Максимално налягане",
  "reports.maxPressureMagnitude24h": "Максимален магнитуд (/24H)",
  "reports.maxTemperature": "Максимална температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимален магнитуд (/24H)",
  "reports.minHumidity": "Минимална влажност",
  "reports.minMetric": "Минимум – {metric}",
  "reports.minPressure": "Минимум на налягане",
  "reports.minPressureMagnitude24h": "Минимален магнитуд (/24H)",
  "reports.minTemperature": "Минимална температура",
  "reports.minTempMagnitude24h": "Минимален магнитуд (/24H)",
  "reports.monthlyHeatingEfficiency": "Месечна ефективност на отоплението",
  "reports.monthlyIndoorReport": "Месечен отчет от измервания в помещението",
  "reports.monthlyOutdoorReport": "Месечен отчет от измервания отвън",
  "reports.monthlyReport": "Месечен отчет",
  "reports.monthlySolarReport": "Месечен отчет за слънчевата активност",
  "reports.monthlyWindReport": "Месечен отчет за вятър",
  "reports.numberOfDays": "Брой дни",
  "reports.onThisDayInHistory": "На този ден в историята",
  "reports.outdoorReport": "Отчет от измервания отвън",
  "reports.rainfall": "Валежи",
  "reports.rainyDays": "Дъждовни дни",
  "reports.recordDailyRain": "Най-дъждовен ден",
  "reports.recordHigh": "Рекордна горещина",
  "reports.recordLow": "Рекорден студ",
  "reports.recordsAndClimatology": "Рекорди и климат",
  "reports.recordsSince": "Рекорди от {date}",
  "reports.recordWindGust": "Най-силен порив на вятъра",
  "reports.relativelyWet": "Относително влажно (60% {lessThan} влажност ≤ 80%)",
  "reports.sendEmail": "Изпратете имейл",
  "reports.summerDays": "Летни дни",
  "reports.tooDry": "Твърде сухо (Влажност ≤ 45%)",
  "reports.tooWet": "Твърде влажно (Влажност {greaterThan} 80%)",
  "reports.tropicalNights": "Тропически нощи",
  "reports.warmestMonthRanking": "Най-топъл {month} в историята",
  "reports.waterBalance": "Воден баланс",
  "reports.yearsOfData": "Данни за {years, plural, one {# година} other {# години}}",
  "reports.yearToDateTemperature": "Температура от началото на годината",
  "reports.yearToDateTemperatureComparison": "Сравнение на температурата от година до дата",
  "sensors.aqiByChannel": "AQI по канал",
  "sensors.bgtSensors": "Черна сфера и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareAqi": "Сравнение на AQI",
  "sensors.compareHumidity": "Сравнение на влажността",
  "sensors.compareMoisture": "Сравнение на влагата",
  "sensors.comparePm25": "Сравнение на PM2.5",
  "sensors.compareTemperatures": "Сравнение на температурите",
  "sensors.depthByChannel": "Дълбочина по канал",
  "sensors.heatStressExtreme": "Екстремен топлинен стрес",
  "sensors.heatStressModerate": "Умерен топлинен стрес",
  "sensors.heatStressNone": "Няма топлинен стрес",
  "sensors.heatStressStrong": "Силен топлинен стрес",
  "sensors.heatStressVeryStrong": "Много силен топлинен стрес",
  "sensors.humidityByChannel": "Влажност по канал",
  "sensors.indoorAirQuality": "Качество на въздуха вътре",
  "sensors.indoorAirQualityPm": "PM2.5 и PM10 AQI",
  "sensors.indoorClimate": "Вътрешен климат",
  "sensors.indoorCo2Levels": "Нива на CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажност",
  "sensors.last24Hours": "24 часа",
  "sensors.last30Days": "30 дни",
  "sensors.last7Days": "7 дни",
  "sensors.leafTemperatureByChannel": "Температура на листата по канал",
  "sensors.leafWetnessByChannel": "Влажност на листата по канал",
  "sensors.lightningSensor": "Мълния",
  "sensors.moistureByChannel": "Влага по канал",
  "sensors.noDataAvailable": "Няма налични данни",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по канал",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Изберете канал",
  "sensors.sensorDetailDescription": "Преглед на исторически данни и тенденции за каналите на сензора.",
  "sensors.sensorHistory": "История на сензора",
  "sensors.soilConductivityByChannel": "Проводимост по канал",
  "sensors.soilTemperatureByChannel": "Температура на почвата по канал",
  "sensors.strikesToday": "Удари днес",
  "sensors.temperatureByChannel": "Температура по канал",
  "sensors.viewChart": "Преглед на графиката",
  "settings.about": "Относно",
  "settings.aboutDescription": "Лицензионно споразумение, политика за поверителност",
  "settings.account": "Акаунт",
  "settings.accountDescription": "Профил, смяна на парола",
  "settings.accountIntro": "Данни за вашия акаунт:",
  "settings.accountSection": "Акаунт",
  "settings.appearance": "Външен вид",
  "settings.appearanceDescription": "Тема и опции за показване",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арабски",
  "settings.availableServices": "Налични",
  "settings.bulgarian": "български",
  "settings.cannotDisconnectLastAccount": "Не може да прекъснете единствения си метод за вход. Моля, първо добавете друг метод за вход.",
  "settings.catalan": "каталонски",
  "settings.changeEmail": "Промяна на имейл",
  "settings.changePassword": "Промяна на паролата",
  "settings.chartGestures": "Жестове върху графики",
  "settings.chartGesturesDescription": "Плъзгането върху диаграмите променя периода от време, прищипването на диаграмите променя времевата скала",
  "settings.connect": "Свързване",
  "settings.connected": "Свързано",
  "settings.connectedAccounts": "Свързани акаунти",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Свързани",
  "settings.connectedSince": "Свързано от {date}",
  "settings.connectionSuccess": "Профилът {provider} е свързан успешно",
  "settings.contactUs": "Свържете се с нас",
  "settings.contactUsDescription": "Получете помощ или изпратете обратна връзка",
  "settings.croatian": "хърватски",
  "settings.currentPassword": "Текуща парола",
  "settings.czech": "чешки",
  "settings.danish": "датски",
  "settings.dark": "Тъмна тема",
  "settings.dataDisplay": "Показване на данни",
  "settings.dateAndTime": "Дата и час",
  "settings.disconnect": "Прекъсване",
  "settings.disconnectConfirmation": "Сигурни ли сте, че искате да прекъснете профила си {provider}?",
  "settings.disconnectionSuccess": "Профилът {provider} е прекъснат успешно",
  "settings.donateButton": "Направете дарение",
  "settings.donateDescription": "SmartMixin се разработва от малък екип. Ако ви е полезен, можете да подкрепите развитието му с еднократно дарение в произволен размер. Това е подарък — не променя плана ви и не отключва никакви функции.",
  "settings.donateSuccessBody": "Вашето дарение помага на SmartMixin да продължи да работи и да се подобрява. Наистина го оценяваме.",
  "settings.donateSuccessTitle": "Благодарим за подкрепата!",
  "settings.donateTitle": "Подкрепете SmartMixin",
  "settings.dutch": "холандски",
  "settings.emailChange": "Промяна на имейл адрес",
  "settings.emailChangeConfirmation": "Потвърждение за промяна на имейл",
  "settings.emailChangeFailure": "Линкът за промяна на имейл е невалиден или е изтекъл.",
  "settings.emailChangeSuccess": "Вашият имейл беше успешно променен на {newEmail}.",
  "settings.emailChangeVerificationSent": "Имейл за потвърждение беше изпратен на новия ви имейл адрес. Моля, проверете входящата си поща и кликнете върху линка, за да потвърдите промяната.",
  "settings.english": "английски",
  "settings.forecastModelOrderEmpty": "Няма запазен ред — използваме GFS по подразбиране.",
  "settings.forecastModelOrderFreeHint": "Премиум моделите изискват абонамент за SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Избираме първия модел от списъка ви, който покрива всяка станция.",
  "settings.forecastModelOrderReset": "Възстанови",
  "settings.forecastModelOrderTitle": "Прогностичен модел по подразбиране",
  "settings.forecastModels": "Прогностични модели",
  "settings.forecastModelsDescription": "Подреди по предпочитание",
  "settings.french": "френски",
  "settings.german": "немски",
  "settings.gestures": "Жестове",
  "settings.greek": "гръцки",
  "settings.helpCenter": "Помощен център",
  "settings.helpCenterDescription": "Често задавани въпроси и ръководства",
  "settings.hungarian": "унгарски",
  "settings.integrationsSection": "Интеграции",
  "settings.italian": "италиански",
  "settings.japanese": "японски",
  "settings.korean": "корейски",
  "settings.language": "Език",
  "settings.languageDescription": "Предпочитан език",
  "settings.light": "Светла тема",
  "settings.newEmailAddress": "Нов имейл адрес",
  "settings.newPassword": "Нова парола",
  "settings.newPasswordAgain": "Повторете новата парола",
  "settings.norwegian": "норвежки",
  "settings.notConnected": "Не е свързано",
  "settings.notificationsSection": "Известия",
  "settings.oldPassword": "Стара парола",
  "settings.ongoingNotificationEnabled": "Активиране на постоянно известие",
  "settings.ongoingNotificationMetrics": "Показвани измервания",
  "settings.ongoingNotificationMetricsHint": "Плъзнете, за да пренаредите избраните измервания",
  "settings.ongoingNotificationPermissionRequired": "Изисква се разрешение за известия",
  "settings.ongoingNotificationStation": "Метеорологична станция",
  "settings.passwordChange": "Промяна на паролата",
  "settings.polish": "полски",
  "settings.portuguese": "португалски",
  "settings.preferencesSection": "Предпочитания",
  "settings.premium": "Премиум",
  "settings.premiumActive": "Активен",
  "settings.premiumAnnualThenPrice": "След това 9,99 €/година",
  "settings.premiumAnnualTrialInfo": "Започнете с безплатен пробен период от {days} дни",
  "settings.premiumCurrentPlan": "Текущ план",
  "settings.premiumDescription": "Отключете премиум функциите",
  "settings.premiumDownloadApp": "Изтеглете приложението, за да се абонирате:",
  "settings.premiumExpiresOn": "Подновява се на {date}",
  "settings.premiumFreePlan": "Безплатно",
  "settings.premiumInactive": "Без абонамент",
  "settings.premiumManageWebSubscription": "Управлявайте абонамента си, актуализирайте метода на плащане или анулирайте.",
  "settings.premiumPremiumPlan": "Премиум",
  "settings.premiumSubscribeAnnual": "Годишно — 9,99 €/година",
  "settings.premiumSubscribedOn": "Абониран чрез {platform}",
  "settings.premiumSubscribeMonthly": "Месечно — 1,99 €/месец",
  "settings.premiumSubscribeOnWeb": "Абонирайте се сега, за да отключите всички премиум функции.",
  "settings.premiumSubscriptionSuccess": "Вашият абонамент е активиран! Насладете се на всички премиум функции.",
  "settings.premiumSubscriptionSuccessTitle": "Добре дошли в Premium!",
  "settings.premiumWebappNotice": "Абонаментите могат да бъдат закупени само през мобилното приложение SmartMixin на iOS или Android.",
  "settings.privacyPolicy": "Политика за поверителност",
  "settings.profile": "Профил",
  "settings.russian": "руски",
  "settings.serbian": "сръбски",
  "settings.settings": "Настройки",
  "settings.slovak": "словашки",
  "settings.smallDecimals": "Малки десетични",
  "settings.smallDecimalsDescription": "Показване на десетичните цифри в по-малък размер",
  "settings.socialConnectionsIntro": "Свържете социалните си профили за бърз вход. Можете да свързвате или прекъсвате профили по всяко време.",
  "settings.spanish": "испански",
  "settings.statusBarWidget": "Уиджет за лентата на състоянието",
  "settings.statusBarWidgetDescription": "Винаги видими метеорологични данни",
  "settings.subscriptionSection": "Абонамент",
  "settings.supportSection": "Поддръжка",
  "settings.swedish": "шведски",
  "settings.systemTheme": "Системна тема",
  "settings.termsOfService": "Условия за ползване",
  "settings.turkish": "турски",
  "settings.ukrainian": "украински",
  "settings.units": "Единици",
  "settings.unitsDescription": "Мерни единици в приложението",
  "settings.update": "Обновете",
  "settings.updateYourProfile": "Обновете профила си",
  "settings.weatherServices": "Метеорологични услуги",
  "settings.weatherServicesConnected": "{count, plural, =0 {Няма свързани услуги} one {# свързана услуга} other {# свързани услуги}}",
  "settings.weatherServicesDescription": "Свържете Netatmo, Davis, Weatherflow и други",
  "settings.windDirectionConvention": "Стрелка за посока на вятъра",
  "settings.windDirectionConventionDescription": "Изберете как да се показват стрелките за посока на вятъра",
  "settings.windDirectionMeteorological": "Посока на произход",
  "settings.windDirectionMeteorologicalDescription": "Стрелката показва откъде духа вятърът (метеорологична конвенция)",
  "settings.windDirectionOceanographic": "Посока на потока",
  "settings.windDirectionOceanographicDescription": "Стрелката показва накъде духа вятърът (океанографска конвенция)",
  "units.absolutePressure": "Абсолютно налягане",
  "units.airDensity": "Плътност на въздуха",
  "units.airGap": "Въздушна междина",
  "units.apparentTemperature": "Привидна температура",
  "units.AQI": "Индекс на качеството на въздуха",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Средно",
  "units.beaufort": "Бофорт",
  "units.blackGlobeTemperature": "Темп. черна сфера",
  "units.boilerOn": "Нагревател ВКЛ",
  "units.co2": "CO2",
  "units.conductivity": "Проводимост",
  "units.coolingDegreeDays": "Охлаждащи дни",
  "units.dailyHeatingDuration": "Продължителност на отопляване през деня",
  "units.dailyPrecipitation": "Дневни валежи",
  "units.dailyRain": "Дневен дъжд",
  "units.degreeDay": "Степен на отопляемост",
  "units.degreeDayShort": "DD",
  "units.depth": "Дълбочина",
  "units.depthSensors": "Сензори за дълбочина",
  "units.dewPoint": "Точка на оросяване",
  "units.distance": "Разстояние",
  "units.downTrend": "Надолу",
  "units.E": "И",
  "units.E_long": "Изток",
  "units.ENE": "ИСИ",
  "units.ENE_long": "Изток-Североизток",
  "units.ESE": "ИЮИ",
  "units.ESE_long": "Изток-Югоизток",
  "units.ET": "Евапотранспирация",
  "units.ETshort": "ET",
  "units.feelLike": "Усеща се като",
  "units.feelsLike": "Усеща се като",
  "units.footMile": "Фут, миля",
  "units.frostPoint": "точка на замръзване",
  "units.gust": "Порив",
  "units.heatIndex": "Топлинен индекс",
  "units.heatingDegreeDays": "Отопляеми дни",
  "units.heatingPower": "Отоплителна мощност",
  "units.humidex": "Humidex",
  "units.humidity": "Влажност",
  "units.inch": "Инч",
  "units.inchOfMercury": "Инч живачен стълб",
  "units.kilometerPerHour": "Километри в час",
  "units.knot": "Възел морски",
  "units.last12Hours": "Последните 12 часа",
  "units.last24Hours": "Последните 24 часа",
  "units.last3Hours": "Последните 3 часа",
  "units.last6Hours": "Последните 6 часа",
  "units.lastHour": "Последен час",
  "units.lastLightningImpact": "Последен удар",
  "units.lastMeasure": "Последно измерване",
  "units.leafSensors": "Сензори за листа",
  "units.leafWetness": "Влажност на листата",
  "units.lightningDistance": "Разстояние",
  "units.lightningStrikeCount": "Брой мълнии",
  "units.lightningStrikeDistance": "Разстояние от мълния",
  "units.max": "Макс.",
  "units.max_gust": "Макс. порив",
  "units.max_wind": "Макс. скорост на вятър",
  "units.meterKilometer": "Метър, километър",
  "units.meterPerSecond": "Метри в секунда",
  "units.milePerHour": "Мили в час",
  "units.millibar": "Милибар",
  "units.millimeter": "Милиметър",
  "units.millimeterOfMercury": "Милиметър живачен стълб",
  "units.min": "Мин.",
  "units.N": "С",
  "units.N_long": "Север",
  "units.NE": "СИ",
  "units.NE_long": "Североизток",
  "units.NNE": "ССИ",
  "units.NNE_long": "Север-Североизток",
  "units.NNW": "ССЗ",
  "units.NNW_long": "Север-Северозапад",
  "units.noise": "Шум",
  "units.normalizedHeatingCoefficient": "Нормализиран коефициент на нагряване",
  "units.NW": "СЗ",
  "units.NW_long": "Северозапад",
  "units.O3": "Озон",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Валеж",
  "units.pressure": "Налягане",
  "units.rain": "Дъжд",
  "units.rainRate": "Интензивност на дъжда",
  "units.referenceTemperature": "Референтна температура",
  "units.relativePressure": "Относително налягане",
  "units.S": "Ю",
  "units.S_long": "Юг",
  "units.SE": "ЮИ",
  "units.SE_long": "Югоизток",
  "units.setPoint": "Зададена точка",
  "units.snow": "Сняг",
  "units.snowfall": "Снеговалеж",
  "units.soilMoisture": "Влага",
  "units.soilSensors": "Почвени сензори",
  "units.solarEnergy": "Слънчева енергия",
  "units.solarRadiation": "Слънчево излъчване",
  "units.speed": "Скорост",
  "units.SSE": "ЮЮИ",
  "units.SSE_long": "Юг-Югоизток",
  "units.SSW": "ЮЮЗ",
  "units.SSW_long": "Юг-Югозапад",
  "units.stableTrend": "Стабилен",
  "units.sum": "Сума",
  "units.SW": "ЮЗ",
  "units.SW_long": "Югозапад",
  "units.temperature": "Температура",
  "units.temperatureAndHumiditySensors": "Сензори за температура и влажност",
  "units.temperatureSensors": "Сензори за температура и влажност",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Днес",
  "units.upTrend": "нагоре",
  "units.uv": "UV",
  "units.visibility": "Видимост",
  "units.W": "З",
  "units.W_long": "Запад",
  "units.wetBulbGlobeTemperature": "Темп. мокра сфера",
  "units.wetBulbTemperature": "Wet bulb температура",
  "units.wind": "Вятър",
  "units.windChill": "Wind Chill",
  "units.windDirection": "Посока на вятъра",
  "units.windRun": "ход на вятъра",
  "units.windRunDescription": "Пътуването на вятъра е общото разстояние, изминато от вятъра за определен период от време",
  "units.WNW": "ЗСЗ",
  "units.WNW_long": "Запад-Северозапад",
  "units.WSW": "ЗЮЗ",
  "units.WSW_long": "Запад-Югозапад"
}
